import { formatSearch } from "components-for/filters/explore-filters/explore-filters.utilities";
import { IExploreFilters } from "components-for/filters/explore-filters/explore-filters.types";
import { startOfDay, subDays } from "date-fns";
import {
    IInteractionMaximumMetricParameters,
    IInteractionMinimumMetricParameters,
    IInteractionsGetQueryParameters,
} from "@edgetier/watchtower-types";

const DEFAULT_DAY_RANGE = 7;

/**
 * Remove selected metric's value(s) if it has any from form values or query parameters.
 * @param minimumFieldName Name of the field containing the minimum value for this metric.
 * @param maximumFieldName Name of the field containing the maximum value for this metric.
 * @param parameters       Form values or URL parameters.
 */
export const omitCurrentMetricValues = (
    minimumFieldName: keyof IInteractionMinimumMetricParameters,
    maximumFieldName: keyof IInteractionMaximumMetricParameters,
    parameters: IInteractionsGetQueryParameters
) => {
    const { [minimumFieldName]: mimimumValue, [maximumFieldName]: maximumValue, ...otherParameters } = parameters;
    return otherParameters;
};

/**
 * Get the parameters that will be sent to the distribution request. This is basically all the other filters, with the
 * current metric excluded.
 * @param minimumFieldName           Name of the field containing the minimum value for this metric.
 * @param maximumFieldName           Name of the field containing the maximum value for this metric.
 * @param formValues                 Form values
 * @param interactionQueryParameters URL search parameters
 * @returns                          Parameters to use when getting the interaction metric's distribution.
 */
export const createQueryParameters = (
    minimumFieldName: keyof IInteractionMinimumMetricParameters,
    maximumFieldName: keyof IInteractionMaximumMetricParameters,
    interactionQueryParameters: IInteractionsGetQueryParameters,
    formValues: IExploreFilters
) => {
    // Get details for all filled fields available
    const { searchValues: formattedFormValues } = formatSearch(formValues, []);

    const parameters = { ...interactionQueryParameters, ...formattedFormValues };
    const updatedSearchParameters = omitCurrentMetricValues(minimumFieldName, maximumFieldName, parameters);

    const defaultStartDateTime = startOfDay(subDays(new Date(), DEFAULT_DAY_RANGE));
    return { startDateTime: defaultStartDateTime, ...updatedSearchParameters };
};
